import { Alert, Button, Stack } from '@mantine/core';
import * as React from 'react';

type ErrorAlertProps = {
  className?: string;
  message?: string;
  onRetry?: () => void;
  retryButtonText?: string;
};

const ErrorAlert: React.FC<ErrorAlertProps> = ({
  className,
  message = 'Произошла ошибка, попробуйте повторить позже',
  onRetry,
  retryButtonText = 'Повторить',
}) => {
  return (
    <Alert className={className} color="red" variant="light">
      <Stack align="flex-start" gap="sm">
        {message}
        {onRetry && (
          <Button size="xs" variant="outline" onClick={onRetry}>
            {retryButtonText}
          </Button>
        )}
      </Stack>
    </Alert>
  );
};

export default ErrorAlert;
